export default "__VITE_ASSET__G1$f$lT$__"